import { apiClient, ApiResponse } from './client'

// ============================================================================
// Types
// ============================================================================

export interface Announcement {
  announcementId: number
  title: string
  content: string
  contentFormat: string
  status: string
  isPinned: boolean
  isGlobal: boolean
  targetAppTypes?: string[] | null
  targetOrganizationIds?: number[] | null
  publishStartAt: string | null
  publishEndAt: string | null
  viewCount: number
  authorId: number
  authorName: string
  isRead?: boolean
  createdAt: string
  updatedAt: string
}

export interface AnnouncementListResponse {
  announcements: Announcement[]
  totalCount: number
  page: number
  size: number
  totalPages: number
}

export interface UnreadCountResponse {
  unreadCount: number
}

// ============================================================================
// API Functions
// ============================================================================

export const announcementApi = {
  /**
   * Get announcement list for B2B users
   */
  getList: async (params: {
    page?: number
    size?: number
    keyword?: string
  } = {}): Promise<AnnouncementListResponse> => {
    const response = await apiClient.get<ApiResponse<AnnouncementListResponse>>(
      '/b2b/announcements',
      { params }
    )
    if (!response.data.data) {
      throw new Error('Failed to fetch announcements')
    }
    return response.data.data
  },

  /**
   * Get announcement by ID
   */
  getById: async (id: number): Promise<Announcement> => {
    const response = await apiClient.get<ApiResponse<Announcement>>(
      `/b2b/announcements/${id}`
    )
    if (!response.data.data) {
      throw new Error('Announcement not found')
    }
    return response.data.data
  },

  /**
   * Get unread announcement count
   */
  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await apiClient.get<ApiResponse<UnreadCountResponse>>(
      '/b2b/announcements/unread-count'
    )
    if (!response.data.data) {
      return { unreadCount: 0 }
    }
    return response.data.data
  },

  /**
   * Mark announcement as read
   */
  markAsRead: async (id: number): Promise<void> => {
    await apiClient.post(`/b2b/announcements/${id}/read`)
  },
}
